module.exports = __webpack_public_path__ + "static/media/calendario-mujer.6057e8f8.png";